import { Controller } from "@hotwired/stimulus"

// Formularz reguły automatyzacji: pokazuje sekcje właściwe dla wybranego triggera
// (event/schedule/time_offset/segment); pola ukrytych sekcji są disabled, żeby nie
// wysyłały wartości. Dla triggera segment pobiera podgląd liczby wyników filtra.
export default class extends Controller {
  static targets = ["triggerKind", "eventSection", "scheduleSection", "timeOffsetSection",
    "segmentSection", "segmentSelect", "segmentCount", "hoursSection"]

  static values = { countUrl: String, resultsLabel: String }

  connect() {
    this.toggle()
  }

  toggle() {
    const trigger = this.triggerKindTarget.value
    this.toggleSection(this.eventSectionTarget, trigger === "event")
    this.toggleSection(this.scheduleSectionTarget, trigger === "schedule")
    this.toggleSection(this.timeOffsetSectionTarget, trigger === "time_offset")
    if (this.hasSegmentSectionTarget) {
      this.toggleSection(this.segmentSectionTarget, trigger === "segment")
      if (trigger === "segment") this.refreshSegmentCount()
    }
    // okno godzin tylko dla event/time_offset - przy schedule/segment KIEDY ustala harmonogram,
    // a okno byłoby pułapką (np. harmonogram 9:00 + okno 10-12 = reguła nigdy nie działa)
    if (this.hasHoursSectionTarget) {
      this.toggleSection(this.hoursSectionTarget, trigger === "event" || trigger === "time_offset")
    }
  }

  toggleSection(section, visible) {
    section.hidden = !visible
    section.querySelectorAll("select, input, textarea").forEach((el) => {
      el.disabled = !visible
    })
  }

  // Podgląd liczby wyników wybranego filtra (pełne wyszukiwanie: pola + warunki) -
  // user widzi skalę zanim zapisze regułę
  async refreshSegmentCount() {
    if (!this.hasSegmentSelectTarget || !this.hasSegmentCountTarget || !this.countUrlValue) return
    const id = this.segmentSelectTarget.value
    this.segmentCountTarget.textContent = ""
    if (!id) return

    // anuluj poprzedni fetch - spóźniona odpowiedź nie nadpisze liczby aktualnego filtra
    this.countAbort?.abort()
    this.countAbort = new AbortController()

    try {
      const res = await fetch(`${this.countUrlValue}.json?segment_id=${encodeURIComponent(id)}`,
        { headers: { Accept: "application/json" }, signal: this.countAbort.signal })
      if (res.ok) {
        const data = await res.json()
        if (data.count != null) this.segmentCountTarget.textContent = `≈ ${data.count} ${this.resultsLabelValue} · `
      }
    } catch { /* podgląd liczby to dodatek - brak nie blokuje formularza */ }
  }
}
